import Chip from '@mui/material/Chip'
import { useDispatch, useSelector } from 'react-redux'
import styled from '@emotion/styled'
import { getUnits, setFilters, setPage } from '../../actions/viewerActions'
import Grid from '@mui/material/Grid'

const ChipsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
  marginBottom: '1rem'
}))

const ChipStyle = styled(Chip)(({ theme }) => ({
  margin: '0 10px 10px 0'
}))

const FiltersChips = () => {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.viewer.filters)
  const excluded = ['page', 'max']

  const handleDelete = (_filter) => {
    const filtered = {}
    Object.keys(filters).filter(filter => filter !== _filter).forEach((filter) => {
      filtered[filter] = filters[filter]
    })

    dispatch(setFilters(filtered)).then(() => {
      dispatch(setPage(1))
      dispatch(getUnits(filtered))
    })
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <ChipsContainer>
      {Object.keys(filters).filter(filter => !excluded.includes(filter)).map((filter, index) => {
        return (
        // eslint-disable-next-line react/prop-types

            <ChipStyle
              color="primary"
              key={index}
              label={`${filter}: ${filters[filter]}`}
              onDelete={ () => handleDelete(filter)}
            />
        )
      })}
    </ChipsContainer>
      </Grid>
    </Grid>
  )
}

export default FiltersChips
